import React, { useContext } from 'react'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import CategoryProductList from '../../Core/ListComponents/CategoryProductList'
import StandardCategoryBanner from '../../Core/Banners/StandardCategoryBanner'

const CategoryStandard = ({ category, parents }) => {
   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)

   return (
      <React.Fragment>
         <StandardCategoryBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
         />
         <CategoryProductList
            category={category}
         ></CategoryProductList>
         <RenderCustomElements items={items} />
      </React.Fragment>
   )
}

export default CategoryStandard
